<template>
  <SfSidebar
    :visible="isVisible"
    class="sf-sidebar--right sf-sidebar--icon sf-sidebar__eu-warranty"
    @close="closeModal"
  >
    <div class="eu-warranty-sidebar">
      <SfHeading
        class="sf-heading--left"
        title="Ihre gesetzlichen Gewährleistungsrechte"
        :level="2"
      />
      <a
        class="eu-warranty-label"
        href="https://europa.eu/youreurope/business/dealing-with-customers/consumer-contracts-guarantees/eu-legal-guarantee-notice-and-garan-label/index_de.htm"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/logo/eu-gewaehrleistungslabel-de.svg"
          alt="EU-Gewährleistungslabel – gesetzliche Gewährleistung"
          width="595"
          height="842"
        >
      </a>
      <p class="eu-warranty-label-url">
        <a
          href="https://europa.eu/youreurope/business/dealing-with-customers/consumer-contracts-guarantees/eu-legal-guarantee-notice-and-garan-label/index_de.htm"
          target="_blank"
          rel="noopener noreferrer"
        >https://europa.eu/youreurope/business/dealing-with-customers/consumer-contracts-guarantees/eu-legal-guarantee-notice-and-garan-label/index_de.htm</a>
      </p>
    </div>
  </SfSidebar>
</template>

<script>
import { SfSidebar, SfHeading } from '@storefront-ui/vue'

export default {
  name: 'SidebarEuWarranty',
  components: { SfSidebar, SfHeading },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  methods: {
    closeModal () {
      this.$emit('close', this.modalData.name)
    }
  }
}
</script>

<style lang="scss">
.sf-sidebar__eu-warranty {
  .eu-warranty-label {
    display: block;
    margin-top: 16px;

    img {
      display: block;
      width: 100%;
      height: auto;
      background: #fff;
    }
  }

  .eu-warranty-label-url {
    margin: 12px 0 0;
    word-break: break-all;

    a {
      text-decoration: underline;
    }
  }
}
</style>
